import React, { useState } from 'react';
import {
  PT_PEOPLE_ADD,
  PT_PEOPLE_EMPTY,
  PT_PEOPLE_HEADING,
  PT_PEOPLE_REMOVE_ARIA,
} from '../../utils/writerCopy';

/**
 * People named in a scene (spec: docs/plottrack/plot-track-time-people-and-canon-room-spec.md §2).
 * Offered from Book Notes names in the scene's plan and prose; the writer removes (✕) or adds.
 * A removed person stays removed.
 */
export default function PlotTrackScenePeople({ people, pool, onSet }) {
  const [busy, setBusy] = useState(false);
  const current = people || [];
  const here = new Set(current.map((person) => String(person.id)));
  const addable = (pool || []).filter((person) => !here.has(String(person.id)));
  const run = async (fn) => {
    setBusy(true);
    try { await fn(); } finally { setBusy(false); }
  };
  return (
    <section className="pt-people" aria-label={PT_PEOPLE_HEADING}>
      <h3 className="pt-people__heading">{PT_PEOPLE_HEADING}</h3>
      {current.length === 0 && <p className="pt-people__empty">{PT_PEOPLE_EMPTY}</p>}
      {current.length > 0 && (
        <ul className="pt-people__list">
          {current.map((person) => (
            <li key={person.id} className="pt-people__chip">
              <span>{person.name}</span>
              <button
                type="button"
                className="pt-people__remove"
                aria-label={PT_PEOPLE_REMOVE_ARIA(person.name)}
                disabled={busy}
                onClick={() => run(() => onSet(person.id, false))}
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
      {addable.length > 0 && (
        <select
          className="pt-people__add"
          value=""
          aria-label={PT_PEOPLE_ADD}
          disabled={busy}
          onChange={(e) => { const id = e.target.value; if (id) run(() => onSet(id, true)); }}
        >
          <option value="">{PT_PEOPLE_ADD}</option>
          {addable.map((person) => <option key={person.id} value={person.id}>{person.name}</option>)}
        </select>
      )}
    </section>
  );
}
